export default __webpack_public_path__ + "static/brand-logo-browns-74157fbdfa88a59160e8473d8d4f6dc3.png";